import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { Users, UserCheck, UserX, Building2, Mail, Sparkles, ArrowRight } from "lucide-react";

export default function OrgDashboard() {
  const [data, setData] = useState(null);
  useEffect(() => { api.get("/org/dashboard-stats").then((r)=>setData(r.data)).catch(()=>{}); }, []);
  if (!data) return <div className="text-slate-500">Chargement…</div>;
  const stats = [
    { label: "Membres total",    value: data.members.total,     icon: Users,     c: "text-slate-900" },
    { label: "Membres actifs",   value: data.members.active,    icon: UserCheck, c: "text-emerald-600" },
    { label: "Inactifs / suspendus", value: (data.members.inactive || 0) + (data.members.suspended || 0), icon: UserX, c: "text-amber-600" },
    { label: "Invitations en attente", value: data.invitations_pending, icon: Mail, c: "text-blue-600" },
  ];
  return (
    <div data-testid="org-dashboard-page">
      <div className="flex items-center gap-3">
        <Building2 className="text-emerald-700" size={26}/>
        <div>
          <h1 className="font-heading text-2xl md:text-3xl font-bold" data-testid="org-dashboard-title">{data.organization.name}</h1>
          <div className="text-xs text-slate-500">{data.organization.type_label} · Statut : <b className="text-emerald-700">{data.organization.status}</b></div>
        </div>
      </div>

      <div className="mt-6 grid grid-cols-2 md:grid-cols-4 gap-3">
        {stats.map((s, i)=>(
          <div key={i} className="bg-white border border-slate-200 rounded-2xl p-4" data-testid={`org-stat-${i}`}>
            <s.icon className={`${s.c}`} size={18}/>
            <div className={`font-heading text-2xl font-extrabold mt-2 ${s.c}`}>{s.value}</div>
            <div className="text-[10px] uppercase tracking-widest text-slate-500 font-bold mt-0.5">{s.label}</div>
          </div>
        ))}
      </div>

      <div className="mt-6 grid md:grid-cols-2 gap-4">
        <div className="bg-white border border-slate-200 rounded-2xl p-5">
          <div className="flex items-center justify-between mb-3">
            <h2 className="font-heading font-bold">Derniers membres</h2>
            <Link to="/organisme/membres" className="text-xs text-[#E05638] font-semibold hover:underline inline-flex items-center gap-1">Tout voir <ArrowRight size={12}/></Link>
          </div>
          {(data.latest_members || []).length === 0 ? (
            <div className="text-slate-500 text-sm">Aucun membre pour l'instant. <Link to="/organisme/membres" className="text-[#E05638] font-semibold">Ajouter vos premiers membres →</Link></div>
          ) : (
            <ul className="space-y-2">
              {data.latest_members.map((m)=>(
                <li key={m.id} className="flex items-center justify-between text-sm border-b last:border-b-0 border-slate-100 pb-1.5">
                  <span><b>{m.first_name} {m.last_name}</b> · {m.email}</span>
                  <span className={`text-[10px] px-2 py-0.5 rounded font-bold ${m.status === "active" ? "bg-emerald-100 text-emerald-800" : m.status === "suspended" ? "bg-rose-100 text-rose-800" : "bg-slate-100 text-slate-600"}`}>{m.status}</span>
                </li>
              ))}
            </ul>
          )}
        </div>
        <div className="bg-gradient-to-br from-emerald-50 to-orange-50 border border-emerald-200 rounded-2xl p-5">
          <div className="flex items-center gap-2"><Sparkles size={18} className="text-[#E05638]"/><h2 className="font-heading font-bold">Pour bien démarrer</h2></div>
          <ol className="mt-3 space-y-2 text-sm list-decimal list-inside text-slate-700">
            <li>Complétez votre <Link to="/organisme/profil" className="text-[#E05638] font-semibold hover:underline">fiche organisme</Link></li>
            <li>Ajoutez ou <b>importez vos membres</b> via CSV dans <Link to="/organisme/membres" className="text-[#E05638] font-semibold hover:underline">Mes membres</Link></li>
            <li>Partagez votre <b>lien d'invitation unique</b> à vos membres</li>
            <li>Suivez les statistiques dès l'arrivée du Pass (bientôt disponible)</li>
          </ol>
        </div>
      </div>
    </div>
  );
}
